import {
	get,
	post, del, put
} from './request'

/*添加运维项目*/
export const addOperationProject = async (data) => {
	let result = await post(`api/OpsItem`, data)
	return result.data;
}

/*搜索查选运维项目*/
export const searchOperationProject = async (Search) => {
	let result = await get(`api/OpsItem/`, { Search, OrderBy: 'id', OrderType: 'asc' })
	return result.data;
}

/*删除项目*/
export const deleteOperationProject = async (Id) => {
	let result = await del(`api/OpsItem/${Id}`);
	return result
}

/*更新项目*/
export const updateOperationProject = async (data) => {
	let result = await put(`api/OpsItem`, data)
	return result;
}

/**
 * 获取所有运维单
 * @param {object} data 
 * @returns 
 */
export const getAllRepair = async (data) => {
	let res = await get('api/repair', data)
	return res.data
}

/**
 * 统计运维单数量
 */

export const getRepairCount = async () => {
	let res = await get('api/opsstatistics',)
	return res.data
}

/**
 * 获取所有故障类型
 */
export const getAllOpsFaultType = async () => {
	let res = await get('api/OpsFaultType')
	return res.data
}

/**
 * 
 * @param {object} data 
 * @returns 
 */
export const getPatrolData = async (data) => {
	let res = await get('api/PatrolData/page', data)
	return res.data
}